import { type PropsWithChildren, useCallback, useMemo, useState } from "react";
import { useUserPreferencesQuery } from "@/entities/user-preferences";
import { createSafeContext } from "@/shared/utils/createSafeContext";

interface CollapsibleViewContextValue {
    isCollapsed: boolean;
    setCollapsibleView: (value: boolean) => void;
}

const [CollapsibleViewProviderBase, useCollapsibleViewContext] =
    createSafeContext<CollapsibleViewContextValue>("CollapsibleViewContext");

export { useCollapsibleViewContext };

export const CollapsibleViewProvider = ({ children }: PropsWithChildren) => {
    const { data: userPreference } = useUserPreferencesQuery();
    const showMoreOptions = userPreference?.showMoreOptions ?? false;
    const initialIsCollapsed = !showMoreOptions;

    const [isCollapsed, setIsCollapsed] = useState(initialIsCollapsed);

    const setCollapsibleView = useCallback((value: boolean) => {
        setIsCollapsed(value);
    }, []);

    const value = useMemo(() => ({ isCollapsed, setCollapsibleView }), [isCollapsed, setCollapsibleView]);

    return <CollapsibleViewProviderBase value={value}>{children}</CollapsibleViewProviderBase>;
};
